import './box.css'

import classNames from 'classnames'
import { ANIMATION_DELAY } from 'constants.js'
import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import { CSSTransition } from 'react-transition-group'
import { noop } from 'utils'

import BoxHeader from './BoxHeader'

class Box extends PureComponent {
  state = {
    isOpen: false,
    storeType: Array.isArray(this.props.boxTitles) && this.props.boxTitles.length > 0 ? this.props.boxTitles[0].type : null,
  }

  componentDidMount() {
    const { openOnInit } = this.props

    if (openOnInit) {
      this.toggleOpen()
    }
  }

  changeStoresType = (event, type) => {
    event.preventDefault()
    event.stopPropagation()
    this.setState({
      storeType: type,
    })

    if (this.props.updateStoreType) {
      this.props.updateStoreType(type)
    }
  }

  open = () => {
    const { onExpand } = this.props
    const { isOpen } = this.state

    if (!isOpen) {
      onExpand()
      this.setState({ isOpen: true })
    }
  }

  toggleOpen = () => {
    const { onCollapse, onExpand } = this.props

    this.setState(state => {
      if (state.isOpen) {
        onCollapse()
      } else {
        onExpand()
      }

      return {
        isOpen: !state.isOpen,
      }
    })
  }

  render() {
    const { boxClassName, children, collapseContent, EnhancedChildren, headerContent, type, withOpenToggle } = this.props
    const { isOpen, storeType } = this.state

    return (
      <CSSTransition in timeout={ANIMATION_DELAY} classNames="collapse-out">
        <div className={classNames('box', boxClassName)}>
          <BoxHeader
            {...this.props}
            changeType={this.changeStoresType}
            isOpen={isOpen}
            storeType={storeType}
            toggleOpen={withOpenToggle ? this.toggleOpen : undefined}
          >
            {headerContent}
          </BoxHeader>
          <div className={classNames('box-content', type)}>
            {children}
            {EnhancedChildren && React.cloneElement(EnhancedChildren, { open: this.open })}
          </div>
          <CSSTransition in={isOpen} timeout={ANIMATION_DELAY} classNames="collapse-out" unmountOnExit>
            <div className="div-collapse">{collapseContent}</div>
          </CSSTransition>
        </div>
      </CSSTransition>
    )
  }
}

Box.propTypes = {
  boxClassName: PropTypes.string,
  boxTitle: PropTypes.string,
  boxTitles: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string,
    PropTypes.arrayOf(
      PropTypes.shape({
        icon: PropTypes.node,
        title: PropTypes.string,
        type: PropTypes.string,
      }),
    ),
  ]),
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  collapseContent: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  country: PropTypes.number,
  EnhancedChildren: PropTypes.node,
  headerContent: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  logo: PropTypes.string,
  onCollapse: PropTypes.func,
  onExpand: PropTypes.func,
  openOnInit: PropTypes.bool,
  showOpenIcon: PropTypes.bool,
  subheader: PropTypes.node,
  type: PropTypes.string,
  updateStoreType: PropTypes.func,
  withOpenToggle: PropTypes.bool,
}

Box.defaultProps = {
  onCollapse: noop,
  onExpand: noop,
  type: 'country',
  withOpenToggle: true,
}

export default Box
